<template>
  <div id="app">
    <header v-if="!$route.meta.ownsHeader" class="app-logo">
      <Logo variant="desktop" color="brand" :height="24" />
    </header>
    <router-view />
  </div>
</template>

<script lang="ts">
import { addDnsPrefetch } from "@/helpers/prefetchHelper";
import { Logo } from "@payjoy/design-system";
import { defineComponent } from "vue";

export default defineComponent({
  name: "App",
  components: { Logo },
  setup() {
    addDnsPrefetch();

    return {};
  },
});
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap");
@import "@/assets/scss/global.scss";

#app {
  background-color: var(--pj-color-surface-canvas, #fafafa);
  font-family: "Inter", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

.app-logo {
  display: none;
  justify-content: center;
  padding: 24px 0 0;
}

@media (min-width: 768px) {
  #app {
    max-width: 400px;
    margin: 0 auto;
  }

  .app-logo {
    display: flex;
  }
}
</style>
